import { ControlDisplayedValue } from "@multiweb/reactComponents";
import { ControlReduxRawValue } from "@multiweb/reactControls";
import { ITextBuilder } from "Global/Base/Builders/ITextBuilder";

/**
 * Raw-hodnota controlu včetně odpovídající `displayedValue` - viz {@link ControlDisplayedValue}.
 * Určeno pro (interní) potřeby `EditableControlConnector.dispalyedValue`.
 */
export class RawAndDisplayedValue implements ITextBuilder {
    /** Raw hodnota. (Např. pro ComboBox může být třeba index do tabulky položek comboBoxu.) */
    private readonly _rawValue: ControlReduxRawValue;
    /**
     * Textová podoba raw-hodnoty určená pro uživatele. (Např. pro ComboBox může být třeba `toString = () => comboBoxItems[rawValue]`.)
     */
    private readonly _displayedValue: ControlDisplayedValue;

    constructor(rawValue: ControlReduxRawValue, displayedValue: string) {
        this._rawValue = rawValue;
        this._displayedValue = displayedValue;
    }

    public get rawValue(): ControlReduxRawValue {
        return this._rawValue;
    }

    public toString(): string | null {
        return this._displayedValue;
    }
}
